import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { fetchGroupdescriptions } from "../services/GrouptripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const ExperienceTripsDtlowerview = () => {
  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [GroupTripsdetail, setGroupTripsdec] = useState(null);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));
      if (res?.data) {
        setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };
    loadBanner();
  }, [id]);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));
      if (res?.status && res?.data?.length > 0) {
        setGroupTripsdec(res.data[0]);
      }
      setLoading(false);
    };
    loadBanner();
  }, [id]);

  // ✅ Helper function to decode HTML entities (&mdash; -> —, &amp; -> &, etc.)
  const decodeHtmlEntities = (text) => {
    if (!text) return "No available information";
    const doc = new DOMParser().parseFromString(text, "text/html");
    return doc.documentElement.textContent;
  };

  // ✅ Activity parser
  const activity = GroupTripsdetail?.activity
    ? GroupTripsdetail.activity
        .split(/\s*@+\s*/)
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
    <>
      <section>
        <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-2 md:mb-4">
          Overview
        </h2>
        <p className="text-slate-600 leading-relaxed text-sm md:text-lg">
          {decodeHtmlEntities(ExperienceTripsDtldata.available_time)}
        </p>

        {ExperienceTripsDtldata?.tage && (
          <div className="mt-4">
            <span className="inline-flex items-center gap-1.5 bg-primary/10 text-primary text-xs md:text-sm font-medium px-3 py-1.5 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-lightbulb h-3.5 w-3.5 md:h-4 md:w-4"
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
              </svg>
              Skill: {ExperienceTripsDtldata?.tage}
            </span>
          </div>
        )}
      </section>

      <section className="mt-6">
        <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-5">
          Take Away from the Trip
        </h2>
        <div className="bg-slate-50 rounded-xl md:rounded-2xl p-4 md:p-6 border border-slate-100">
          <ul className="space-y-3 md:space-y-4">
            {activity.map((place, index) => (
              <li key={index} className="flex items-start gap-3">
                <div className="h-5 w-5 md:h-6 md:w-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-gift h-3 w-3 md:h-3.5 md:w-3.5 text-primary"
                  >
                    <rect x={3} y={8} width={18} height={4} rx={1} />
                    <path d="M12 8v13" />
                    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
                  </svg>
                </div>
                <p className="text-slate-700 text-sm md:text-base leading-relaxed">
                  {place}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default ExperienceTripsDtlowerview;